module.exports = __webpack_public_path__ + "img/stock-m4.bbfbde84.png";